<template>
  <li class="product-item" v-for="(item, index) in data" :key="index" :data-product-no="item.productNo">
    <div class="thumb disabled" v-if="isSoldOut(item)">
      <!-- disabled -->
      <img
        :src="
          item?.files?.[0]?.storedFileName
            ? getImagePath(item.files[0].storedFileName, '480')
            : require('@/assets/static/images/skeleton-food01.svg')
        "
        @error="($event) => onProductImageError($event, item)"
        alt="아주 신선한 젖소 목장 프레쉬 저당 밀크 500ml"
        :loading="index < 4 ? 'eager' : 'lazy'"
        decoding="async"
      />
    </div>
    <div class="thumb" v-else @click="fnView(item)">
      <div class="tag-wrap">
        <span class="tag primary" v-if="item.isNew">NEW</span>
        <span class="tag sale" v-if="item.discountRate"></span>
      </div>
      <div
        class="count-selection-btn-wrap"
        v-if="isSingleProduct(item)"
        :class="{ active: cart?.cart?.[findCartIdx(item)]?.stock }"
      >
        <!-- active -->
        <button class="i-minus" @click.stop="fnReduceStock(item)"></button>
        <label class="number">
          <input type="number" placeholder="" :value="cart.cart[findCartIdx(item)]?.stock ?? 0" readonly @click.stop />
        </label>
        <button
          class="i-plus"
          @click.stop="cart?.cart?.[findCartIdx(item)]?.stock ? fnAddStock(item) : fnAddCart(item)"
        ></button>
      </div>
      <!--      <div
        class="count-selection-btn-wrap"
        :class="{ active: cart?.cart?.[findCartIdx(item)]?.stock }"
        v-else-if="cart?.cart?.[findCartIdx(item)]?.stock"
        @click.stop="fnAddCart(item)"
      >
        <button class="i-minus"></button>
        <label class="number">
          <input type="number" placeholder="" :value="cart.cart[findCartIdx(item)]?.stock ?? 0" readonly @click.stop />
        </label>
        <button class="i-plus"></button>
      </div>-->
      <div class="count-selection-btn-wrap" v-else :class="{ active: getProductCartStock(item) }">
        <button class="i-minus" v-if="getProductCartStock(item)" @click.stop="fnView(item)"></button>
        <label class="number" v-if="getProductCartStock(item)">
          <input type="number" placeholder="" :value="getProductCartStock(item)" readonly @click.stop />
        </label>
        <button class="i-plus" @click.stop="fnAddCart(item)"></button>
      </div>
      <img
        :src="
          item?.files?.[0]?.storedFileName
            ? getImagePath(item.files[0].storedFileName, '480')
            : require('@/assets/static/images/skeleton-food01.svg')
        "
        @error="($event) => onProductImageError($event, item)"
        alt="이미지"
        :loading="index < 4 ? 'eager' : 'lazy'"
        decoding="async"
      />
    </div>
    <div class="product-info">
      <div class="badge-wrap">
        <span class="badge order-total-number"
          >{{ $t('common.chat_order')
          }}<span class="color-primary-dark pd-left02">{{
            item.totalProductOrderCount > 99 ? '99+' : item.totalProductOrderCount
          }}</span></span
        >
        <span class="badge order-total-number" v-if="item.isManageStock">
          재고
          <span
            class="color-primary-dark pd-left02"
            :class="{
              'product-stock-low':
                item.stock !== null && item.stock !== undefined && item.stock !== '' && Number(item.stock) <= 10
            }"
          >
            {{ item.stock > 99 ? '99+' : item.stock }}
          </span>
        </span>
      </div>
      <p class="product-title">
        <span class="badge adults" v-if="item.isR18"></span
        >{{ locale === 'ko' ? item.nameKr : locale === 'en' ? item.nameEn : item.nameVn }}
      </p>
      <div class="price-wrap">
        <span class="sale-price" v-if="item.discountRate">{{ Math.round(item.discountRate * 100) }}%</span>
        <span class="price">{{ toVn(Number((item.price - item.price * item.discountRate).toFixed(0))) }}</span>
      </div>
    </div>
  </li>
  <li
    v-if="isPage"
    style="margin-top: 0.5rem; height: 1px"
    class="infinite"
    v-observe-visibility="{
      callback: fetch,
      throttle: 100
    }"
  ></li>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { cloneDeep } from 'lodash';
import { getImagePath } from '@/common/constants/ConstCode';
import { toVn } from '@/common/utils/Currency';
import { useStore } from 'vuex';
import { modalList, show } from '@/common/utils/ControlModal';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { isProductDisplayable } from '@/views/store/product/productAvailability';

const cart = computed(() => $store.getters['cart/getCart']);
const storeInfo = computed(() => $store.getters['store/getStoreInfo']);
const cartStockByProductNo = computed(() => {
  return (cart.value?.cart ?? []).reduce((map, cartItem) => {
    const productNo = Number(cartItem.productNo);
    map.set(productNo, (map.get(productNo) ?? 0) + Number(cartItem.stock ?? 0));
    return map;
  }, new Map());
});
const $store = useStore();
const { push } = useRouter();
const { t } = useI18n();
const emits = defineEmits(['fetch']);

const findCartIdx = (item) => {
  return cart.value?.cart?.findIndex((ele) => {
    return ele.productNo === item.productNo;
  });
};

const getProductCartStock = (item) => {
  return cartStockByProductNo.value.get(Number(item.productNo)) ?? 0;
};

const fetch = async (isVisible) => {
  if (!isVisible) return;
  emits('fetch', false);
  // parameter.value.searchText = inputText.value;
  // if (!storeCategoryNo.value) { return}
  // await $store.dispatch('store/FETCH_CATEGORY_PRODUCTS', {
  //   storeNo: params.storeNo,
  //   productCategoryNo: Util.isEmpty(storeCategoryNo.value) ? 0 : storeCategoryNo.value,
  //   limit: 10
  // });
};

const fnReduceStock = (item) => {
  const selectedPrd = findCartIdx(item);

  if (item < 0) return;
  if (cart.value.cart[selectedPrd].stock <= 0) return;
  const cartNow = cloneDeep(cart.value.cart);
  cartNow[selectedPrd].stock -= 1;

  if (cartNow[selectedPrd].stock === 0) {
    cartNow.splice(selectedPrd, 1);
  }
  $store.commit('cart/setCart', cartNow);
  readyData();
};

const isSoldOut = (item) => !isProductDisplayable(item);

const isSingleProduct = (item) => !item?.optionGroups || item.optionGroups.length === 0;

const fnAddCart = (item) => {
  if (isSoldOut(item)) return;

  if (!orderable.value) {
    // 주문 불가 메시지 노출 필요
    // store.segmented_control.product.cant_order_msg
    show(modalList.Alert, {
      title: '',
      text: t('store.segmented_control.product.cant_order_msg'),
      confirmText: t('modal.need_to_sign_in.confirmText')
    });
    return false;
  }

  const { productNo, storeNo, price, discountRate } = item;
  const storedStoreNo = cart.value.storeNo;

  if (storedStoreNo !== 0 && storeNo !== storedStoreNo) {
    show(modalList.NotSameStoreProduct, {
      content: t('modal.not_same_store_product.content'),
      confirmText: t('modal.not_same_store_product.confirmText'),
      rejectText: t('modal.not_same_store_product.rejectText'),
      confirmCallBack: () => {
        $store.commit('cart/purge');
        fnAddCart(item);
      }
    });
    return false;
  }
  if (isSingleProduct(item)) {
    $store.dispatch('cart/ADD_CART', {
      storeNo,
      cartItem: {
        productNo,
        stock: 1,
        price: price - Number((price * discountRate).toFixed(0)),
        discountRate
      }
    });
    readyData();
  } else fnView(item);
};

const fnView = (item) => {
  const product = cloneDeep(item);
  if (product.files && product.files.length > 0) {
    product.file = product.files[0];
  }
  $store.commit('recent/setRecentStoreInfo', storeInfo.value);
  $store.commit('product/setProduct', product);
  push(`/shop/${item.storeNo}/product/${item.productNo}`);
};

const onProductImageError = (event, item) => {
  const target = event?.target;
  const storedFileName = item?.files?.[0]?.storedFileName;
  if (!target || !storedFileName) return;

  const originPath = getImagePath(storedFileName, 'origin', false);
  if (!originPath || target.src === originPath) return;

  target.src = originPath;
};

const fnAddStock = (item) => {
  const { storeNo, productNo, isManageStock, price, stock, discountRate } = item;
  const selectedPrd = findCartIdx(item);

  // const totalProductStockInCart = cart.value.cart.reduce((sum, item) => {
  //   return item.productNo === productNo ? sum + Number(item.cartStock ?? 0) : sum;
  // }, 0);

  if (isManageStock && cart.value.cart[selectedPrd].stock + 1 > stock) return;
  const cartNow = cloneDeep(cart.value.cart);

  cartNow[selectedPrd].stock += 1;
  $store.commit('cart/setCart', cartNow);
  readyData();
};

const readyData = () => {
  const { storeNo, cart } = $store.getters['cart/getCart'];
  syncCartData(storeNo, cloneDeep(cart));
};

const syncCartData = (storeNo, cart) => {
  $store.dispatch('payment/CART', { storeNo, cart });
};

const orderable = computed(() => {
  return (
    storeInfo?.value.isShow &&
    storeInfo?.value.isActive &&
    storeInfo?.value.isDeliverable &&
    storeInfo?.value.businessStatus === 'OPEN' &&
    storeInfo?.value.isWork
  );
});

const { data, locale, isPage } = defineProps(['data', 'locale', 'isPage', 'searchText']);
</script>

<style scoped>
.product-item {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  border: 1px solid #e5eaed !important;
  border-radius: 1rem !important;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04) !important;
  color: #334155;
  font-size: 1.4rem;
}

.product-item .product-stock-low {
  color: #ff0040 !important;
}

.product-item .thumb {
  position: relative;
  width: 100%;
  height: auto;
  aspect-ratio: 1 / 1;
  margin: 0 !important;
  overflow: hidden;
  border: 0 !important;
  border-radius: 0 !important;
  background: #f8fafc;
}

.product-item .thumb img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-item .product-info {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  padding: 0.6rem 1rem 1rem !important;
}

.product-item .badge-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0;
}

.product-item .badge-wrap .badge {
  min-width: 0;
  margin-right: 0;
  font-size: 1.1rem;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.product-item .product-title {
  display: -webkit-box;
  min-height: 3.64rem;
  margin: 0;
  overflow: hidden;
  color: #334155;
  font-size: 1.4rem !important;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
  word-break: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.product-item .price-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.4rem;
  min-width: 0;
  margin-top: auto;
  color: #0f172a;
  font-size: 1.4rem !important;
  font-weight: 700;
  line-height: 1.3;
}

.product-item .price-wrap .sale-price {
  margin-right: 0;
  color: #168fc7;
}

.product-item .price-wrap .price {
  min-width: 0;
  color: #0f172a;
  font-size: 1.4rem !important;
  overflow-wrap: anywhere;
}

.product-item .count-selection-btn-wrap {
  box-sizing: border-box;
  max-width: calc(100% - 1.2rem);
  border: 1px solid #dce6ea;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.product-item .count-selection-btn-wrap button {
  flex: 0 0 auto;
  cursor: pointer;
}

.product-item .count-selection-btn-wrap button:focus-visible,
.product-item .count-selection-btn-wrap input:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

.product-item .count-selection-btn-wrap .number,
.product-item .count-selection-btn-wrap .number input {
  min-width: 0;
}

.product-item .count-selection-btn-wrap .number input {
  max-width: 100%;
}

.product-item .count-selection-btn-wrap.active {
  border-color: #7dd3fc;
}
</style>
